import { h, Component } from 'preact'
import { EscalatedButton } from './EscalationButtons'

/* eslint-disable import/no-internal-modules */
import { subscribe } from '@insided/deprecated-utils/globals'

type EscalationType = 'zendesk' | 'productboard' | 'salesforce' | 'freshdesk' | 'intercom'

interface Props {
  isEnabled: boolean
  imageName: string
  title: string
  id: string
  escalationType: EscalationType
}

interface State {
  url: string| null
}

type EventType = 'productboard_note_created' | 'zendesk_ticket_created' | 'salesforce_case_created' | 'freshdesk_ticket_created' | 'intercom_conversation_created'

const eventMap = {
  productboard: 'productboard_note_created',
  zendesk: 'zendesk_ticket_created',
  salesforce: 'salesforce_case_created',
  freshdesk: 'freshdesk_ticket_created',
  intercom: 'intercom_conversation_created'
}

class OpenEscalationButton extends Component<Props, State> {
  constructor (props: Props) {
    super(props)
    this.setState({
      url: null
    })
  }

  async componentDidMount () {
    if (eventMap[this.props.escalationType]) {
      subscribe(eventMap[this.props.escalationType] as EventType, (payload) => {
        if (payload.id === this.props.id) {
          this.setState({ url: payload.url })
        }
      })
    }
  }

  render () {
    const { imageName, title, isEnabled, escalationType } = this.props
    const { url } = this.state
    if (!isEnabled) {
      return null
    }
    return (
      <EscalatedButton redirectUrl={url} imageName={imageName} title={title} customClasses={`qa-escalated-link-${escalationType}`} />
    )
  }
}

export default OpenEscalationButton
